import { render, staticRenderFns } from "./obituary.vue?vue&type=template&id=adb45d92&scoped=true&"
import script from "./obituary.vue?vue&type=script&lang=js&"
export * from "./obituary.vue?vue&type=script&lang=js&"
import style0 from "./obituary.vue?vue&type=style&index=0&id=adb45d92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb45d92",
  null
  
)

export default component.exports